import React, { useState, useEffect } from "react"
import CurrentFilterToolbar from "../components/Filters/CurrentFilterToolbar"
import MainCards from "../components/MainCards"
import FilterToolBar from "../components/FilterToolbar"
import FilterButtonDropdownMenu from "../components/FilterButtonDropdownMenu"
import { graphql } from "gatsby"

const IndexPage = props => {
  const isBrowser = typeof window !== "undefined"
  const data = props.data.allDataJson.edges.map(({ node }) => {
    Object.keys(node).map(key => {
      if (typeof node[key] === "string" && node[key]?.includes(" | "))
        node[key] = node[key].split(" | ")
    })
    return node
  })

  // initial object to set currentFilters state
  const nodeOptions = {
    areaOfStudy: [],
    delivery: [],
    degreeType: [],
  }

  // The filter Btns at the top of the screen
  const UIButtons = [
    {
      filter: "areaOfStudy",
      text: "Area of Study",
    },
    {
      filter: "delivery",
      text: "Delivery",
    },
    {
      filter: "degreeType",
      text: "Degree Type",
    },
  ]

  // state of the program
  const [excelData, setExcelData] = useState([])
  const [filterButtons, setFilterButtons] = useState([])
  const [filterButtonsOpen, setFilterButtonsOpen] = useState(false)
  const [currentOption, setCurrentOption] = useState("")
  const [currentFilters, setCurrentFilters] = useState({
    ...nodeOptions,
  })
  const [searchValue, setSearchValue] = useState("")

  const updateSearchUrl = urlObject => {
    if (isBrowser && window?.history?.pushState) {
      let newUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        urlObject.toString()
      if (urlObject.toString() === "") newUrl = newUrl.slice(0, -1)
      window.history.pushState({ path: newUrl }, "", newUrl)
    } else {
      console.error("Your browser does not support query parameters")
    }
  }

  // gets query parameters and sets the currentFilters state accordingly
  const urlParams = new URLSearchParams(
    isBrowser ? window.location.search : null
  )

  useEffect(() => {
    const areaOfStudyParam = urlParams.get("areaOfStudy")
    const deliveryParam = urlParams.get("delivery")
    const degreeTypeParam = urlParams.get("degreeType")
    const searchValueParam = urlParams.get("search")

    const newFilters = {
      areaOfStudy: areaOfStudyParam ? areaOfStudyParam?.split(" | ") : [],
      delivery: deliveryParam ? deliveryParam?.split(" | ") : [],
      degreeType: degreeTypeParam ? degreeTypeParam?.split(" | ") : [],
    }

    setCurrentFilters(newFilters)
    if (searchValueParam) {
      setSearchValue(searchValueParam)
      const input = document.querySelector("#search")
      input.value = searchValueParam
    }
  }, [])

  // This effect is triggered every time the
  // currentFilters or searchValue state changes
  useEffect(() => {
    let newState = [...data]

    if (searchValue === "") {
      urlParams.delete("search")
      updateSearchUrl(urlParams)
    } else {
      urlParams.delete("search")
      urlParams.append("search", searchValue)
      updateSearchUrl(urlParams)
    }

    if (filtersEmpty && searchValue === "") return setExcelData([])

    urlParams.delete("areaOfStudy")
    urlParams.delete("delivery")
    urlParams.delete("degreeType")

    for (const key in currentFilters) {
      let filteredData = []
      if (currentFilters[key].length !== 0) {
        urlParams.append(key, currentFilters[key].join(" | "))
        filteredData = newState.filter(node =>
          currentFilters[key].some(
            filter => node[key] && node[key].includes(filter)
          )
        )
        newState = filteredData
      }
    }

    updateSearchUrl(urlParams)

    newState = newState.filter(node => {
      return (
        node.generatedDegreeName
          .toLowerCase()
          .includes(searchValue.toLowerCase().trim()) ||
        searchValue.split(",").some(keyword => {
          return node.keywords.some(
            word => word.toLowerCase() === keyword.trim().toLowerCase()
          )
        })
      )
    })

    setExcelData(newState)
    // eslint-disable-next-line
  }, [currentFilters, searchValue])

  // Functions

  // returns true if all filters are empty
  const filtersEmpty = Object.keys(currentFilters).every(
    key => currentFilters[key].length === 0
  )

  // resets all of the data
  const reset = () => {
    setFilterButtonsOpen(false)
    setExcelData([])
    setCurrentOption("")
    setSearchValue("")
    setFilterButtons([])
    setCurrentFilters({
      ...nodeOptions,
    })
    urlParams.delete("areaOfStudy")
    urlParams.delete("delivery")
    urlParams.delete("degreeType")
    urlParams.delete("search")
    updateSearchUrl(urlParams)
  }

  // set the currentFilters state
  // this triggers the useEffect hook
  const setFilters = (e, userOption = currentOption) => {
    let btn = e.target.closest(".js-filter-btn")
    if (!btn) btn = e.target
    let newState = { ...currentFilters }

    // remove a filter if an active filter has been clicked
    // otherwise add the filter
    if (newState[userOption].includes(btn.value)) {
      urlParams.delete(userOption)
      updateSearchUrl(urlParams)
      newState[userOption].splice(newState[userOption].indexOf(btn.value), 1)
    } else {
      newState[userOption].push(btn.value)
    }
    setCurrentFilters(newState)
  }

  // change the UI buttons
  const changeButton = button => {
    if (currentOption === button)
      return setFilterButtonsOpen(!filterButtonsOpen)

    setFilterButtonsOpen(true)
    setCurrentOption(button)

    // get a list of all the buttons to display in the buttons dropdown
    // removes duplicates and falsy values
    const buttons = data
      .flatMap(node => {
        return node[button] && node[button]
      })
      .reduce((acc, curVal) => {
        if (!acc.includes(curVal) && curVal) return [...acc, curVal]
        return acc
      }, [])

    setFilterButtons(buttons)
  }

  // set the search value from the user input
  // this will trigger the useEffect hook
  const handleChange = e => {
    e.preventDefault()
    const input = e.target.querySelector("input")
    setSearchValue(input.value)
  }

  return (
    <div>
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4">
      <img src="https://www.enmu.edu/images/academics/degree-programs/degree-finder-physical-science.jpg" width="100%;" alt="Student in Physical Science Lab" />
        <p className="tw-my-4">
          With over 90 degree program options, ENMU likely has the program that
          fits your educational or career goals. Use our degree finder to search
          by keyword, or filter by area of study, degree type and mode of
          delivery.
        </p>
        <FilterToolBar
          handleChange={handleChange}
          UIButtons={UIButtons}
          currentOption={currentOption}
          filterButtonsOpen={filterButtonsOpen}
          reset={reset}
          changeButton={changeButton}
        />
        <FilterButtonDropdownMenu
          filterButtonsOpen={filterButtonsOpen}
          filterButtons={filterButtons}
          setFilters={setFilters}
          currentFilters={currentFilters}
          currentOption={currentOption}
        />
        {!filtersEmpty && (
          <CurrentFilterToolbar
            currentFilters={currentFilters}
            onClick={setFilters}
          />
        )}
        {excelData.length === 0 && (
          <div className="tw-flex tw-flex-col tw-text-center tw-justify-center">
            <p>Use above filters to narrow down your degree options.</p>
          </div>
        )}
        <MainCards excelData={excelData} />
      </div>
    </div>
  )
}

export const pageQuery = graphql`
  query IndexPageQuery {
    allDataJson {
      edges {
        node {
          areaOfStudy
          imageUrlImage {
            childImageSharp {
              gatsbyImageData(width: 400, height: 300, formats: [PNG])
            }
          }
          keywords
          delivery
          degreeType
          description
          generatedDegreeName
          id
          imageUrl
          pageUrl
        }
      }
    }
  }
`

export default IndexPage
